import { Box, Breadcrumbs, Link, makeStyles, Typography } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(theme => ({
    contentHeader: {
        display: "flex",
        justifyContent: "space-between",
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderColor: theme.palette.sparcaLightGrey.main,
        padding: theme.spacing(4),
        alignItems: "center"
    },
}))
const PageHeader = ({pageTitle, links}) => {
    const classes = useStyles()
    return (
        <>
            <Box className={classes.contentHeader}>
                <Box component="div">
                    <Typography variant="h6" component="h2">
                        {pageTitle}
                    </Typography>
                </Box>
                <Box>
                    {links}
                </Box>
            </Box>
        </>
    )
}

export default PageHeader